/*chq-bust:OPTION2-FULLSCREEN-OVERLAY-2026-09-10-v9-SPEED-T2-HYDRATE*/
/* ============================================================================
   CasterHQ Mobile Filter v4 — OPTION 2: Full-screen overlay
   Clean rewrite. Replaces v3 floating pill + bottom sheets.
   - Inline sticky "Filter & Sort" button at top of grid
   - Single full-screen opaque overlay with Filter / Sort tabs
   - Cannot freeze page (overlay fully covers content, no transparent layering)
   ============================================================================ */
(function () {
  'use strict';

  var overlay, openBtn, closeBtn, clearBtn, tabs, panes, form, applyBtn,
      sortRadios, countEl, lastFocused = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- SPEED-T2 JSON HYDRATE (Approach A) ---------- */
  var _chqFacetHydrated = false;
  var GROUP_LABELS = { load: 'Load & Capacity', wheel: 'Wheel & Tread', mount: 'Hardware & Mount', other: 'More Options' };
  var GROUP_ORDER = ['load', 'wheel', 'mount', 'other'];

  function parseChqFacetSource(root) {
    try {
      var el = (root || document).getElementById('chq-facet-source');
      if (!el) return null;
      return JSON.parse(el.textContent || el.innerText || '');
    } catch (e) { return null; }
  }

  function escText(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildOverlayFacetHtml(data) {
    if (!data || !data.filters) return '';
    var byGroup = { load: [], wheel: [], mount: [], other: [] };
    data.filters.forEach(function (f) {
      var g = (f && f.themeGroup) || 'other';
      if (!byGroup[g]) g = 'other';
      byGroup[g].push(f);
    });
    var html = [];
    GROUP_ORDER.forEach(function (g) {
      var filters = byGroup[g];
      if (!filters || !filters.length) return;
      html.push('<section class="chq-facet-group" data-chq-facet-group="' + g + '">');
      html.push('<h3 class="chq-facet-group__title">' + escText(GROUP_LABELS[g] || g) + '</h3>');
      filters.forEach(function (filter) {
        var isCap = !!filter.isCapacity;
        var vals = filter.values || [];
        var showSearch = vals.length > 12;
        var showMore = vals.length > 7 && !isCap;
        var open = (filter.activeCount > 0) || filter.minValue != null || filter.maxValue != null;
        html.push('<details class="chq-facet" data-chq-facet data-filter-key="' + escText(String(filter.label || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')) + '"' + (open ? ' open' : '') + '>');
        html.push('<summary class="chq-facet__summary"><span class="chq-facet__label">' + escText(filter.label) + (filter.activeCount > 0 ? ' <span class="chq-facet__active-count">(' + filter.activeCount + ')</span>' : '') + '</span>');
        html.push('<svg class="chq-facet__chev" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 4.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></summary>');
        html.push('<div class="chq-facet__body">');
        if (filter.activeCount > 0) {
          html.push('<button type="button" class="chq-facet__clear-cat" data-chq-clear-category data-filter-label="' + escText(filter.label) + '">Clear ' + escText(String(filter.label || '').toLowerCase()) + '</button>');
        }
        if (filter.type === 'price_range') {
          var rmax = filter.rangeMax || 0;
          html.push('<div class="chq-facet__range"><div class="chq-facet__range-inputs">');
          html.push('<label>Min <input type="number" name="' + escText(filter.minParam) + '" value="' + (filter.minValue != null ? escText(filter.minValue) : '') + '" min="0" max="' + escText(rmax) + '" placeholder="0" data-chq-range-min></label>');
          html.push('<label>Max <input type="number" name="' + escText(filter.maxParam) + '" value="' + (filter.maxValue != null ? escText(filter.maxValue) : '') + '" min="0" max="' + escText(rmax) + '" placeholder="' + escText(rmax) + '" data-chq-range-max></label>');
          html.push('</div><div class="chq-facet__range-slider" data-chq-range-slider data-range-max="' + escText(rmax) + '">');
          html.push('<div class="chq-facet__range-track"></div><div class="chq-facet__range-fill" data-chq-range-fill></div>');
          html.push('<input type="range" class="chq-facet__range-handle chq-facet__range-handle--min" min="0" max="' + escText(rmax) + '" value="' + (filter.minValue != null ? escText(filter.minValue) : '0') + '" data-chq-slider-min>');
          html.push('<input type="range" class="chq-facet__range-handle chq-facet__range-handle--max" min="0" max="' + escText(rmax) + '" value="' + (filter.maxValue != null ? escText(filter.maxValue) : escText(rmax)) + '" data-chq-slider-max>');
          html.push('</div></div>');
        } else {
          if (isCap) {
            html.push('<div class="chq-chip-row" data-chq-capacity-chips role="group" aria-label="Capacity range presets">');
            html.push('<button type="button" class="chq-chip" data-min="0" data-max="499" aria-pressed="false">Under 500 lbs</button>');
            html.push('<button type="button" class="chq-chip" data-min="500" data-max="999" aria-pressed="false">500–1k</button>');
            html.push('<button type="button" class="chq-chip" data-min="1000" data-max="2499" aria-pressed="false">1k–2.5k</button>');
            html.push('<button type="button" class="chq-chip" data-min="2500" data-max="4999" aria-pressed="false">2.5k–5k</button>');
            html.push('<button type="button" class="chq-chip" data-min="5000" data-max="999999" aria-pressed="false">5k+ lbs</button></div>');
            html.push('<button type="button" class="chq-facet__toggle-list" data-chq-toggle-list aria-expanded="false">Browse exact lbs ▾</button>');
          }
          if (showSearch) {
            html.push('<input type="search" class="chq-facet__search" placeholder="Search ' + escText(String(filter.label || '').toLowerCase()) + '…" data-chq-facet-search aria-label="Search within ' + escText(filter.label) + '">');
          }
          html.push('<ul class="chq-facet__list' + (isCap ? ' is-collapsed' : '') + (showMore ? ' is-truncated' : '') + '" data-chq-facet-list data-initial-visible="7">');
          vals.forEach(function (v) {
            html.push('<li><label class="chq-facet__opt' + (v.disabled ? ' is-disabled' : '') + '">');
            html.push('<input type="checkbox" name="' + escText(v.param || filter.param) + '" value="' + escText(v.value) + '"' + (v.active ? ' checked' : '') + (v.disabled ? ' disabled' : '') + ' data-chq-facet-input data-numeric-value="' + escText(v.numeric != null ? v.numeric : '') + '">');
            html.push('<span class="chq-facet__opt-label">' + escText(v.label) + '</span>');
            html.push('<span class="chq-facet__opt-count">(' + escText(v.count) + ')</span></label></li>');
          });
          html.push('</ul>');
          if (showMore) {
            html.push('<button type="button" class="chq-facet__show-more" data-chq-show-more aria-expanded="false">Show all ' + vals.length + ' <span data-chq-show-more-hidden>(' + Math.max(0, vals.length - 7) + ' more)</span></button>');
          }
        }
        html.push('</div></details>');
      });
      html.push('</section>');
    });
    return html.join('');
  }

  function hydrateMobileFacetsFromSource() {
    if (!form) form = document.getElementById('chq-filter-form');
    if (!form) return false;
    if (form.querySelector('[data-chq-facet-input]')) { _chqFacetHydrated = true; return true; }
    var data = parseChqFacetSource(document);
    if (!data) return false;
    var host = form.querySelector('[data-chq-facet-hydrate-host]');
    var html = buildOverlayFacetHtml(data);
    if (host) {
      host.outerHTML = html;
    } else {
      var hint = form.querySelector('.chq-facet__hydrate-hint');
      if (hint && hint.parentNode) hint.parentNode.remove();
      form.insertAdjacentHTML('beforeend', html);
    }
    _chqFacetHydrated = !!form.querySelector('[data-chq-facet-input]');
    return _chqFacetHydrated;
  }

  function syncFacetStateFromJson(data) {
    if (!data || !data.filters) return;
    if (typeof data.productsCount === 'number' && countEl) {
      countEl.textContent = String(data.productsCount);
    }
    if (data.productsCount === 0) {
      // reuse zero-path via fake
    }
    var map = Object.create(null);
    var fetchedNames = Object.create(null);
    data.filters.forEach(function (f) {
      if (!f || f.type !== 'list') return;
      var pname = f.param || '';
      fetchedNames[pname] = true;
      (f.values || []).forEach(function (v) {
        map[pname + '|' + v.value] = { count: '(' + v.count + ')' };
      });
    });
    var current = document.querySelectorAll('[data-chq-facet-input]');
    for (var j = 0; j < current.length; j++) {
      var ci = current[j];
      var cName = ci.getAttribute('name');
      var cVal = ci.getAttribute('value');
      if (!cName || cVal === null) continue;
      var cRow = ci.closest ? (ci.closest('.chq-facet__opt') || ci.closest('li')) : null;
      if (!cRow) continue;
      if (ci.checked) {
        cRow.classList.remove('is-disabled');
        ci.removeAttribute('disabled');
        continue;
      }
      var state = map[cName + '|' + cVal];
      if (state) {
        cRow.classList.remove('is-disabled');
        ci.removeAttribute('disabled');
        var cntEl = cRow.querySelector('.chq-facet__opt-count');
        if (cntEl && state.count != null) cntEl.textContent = state.count;
      } else if (fetchedNames[cName]) {
        cRow.classList.add('is-disabled');
        ci.setAttribute('disabled', 'disabled');
        var zCnt = cRow.querySelector('.chq-facet__opt-count');
        if (zCnt) zCnt.textContent = '(0)';
      } else {
        cRow.classList.add('is-disabled');
        ci.setAttribute('disabled', 'disabled');
        var zCnt2 = cRow.querySelector('.chq-facet__opt-count');
        if (zCnt2) zCnt2.textContent = '(0)';
      }
    }
  }


  function init() {
    overlay = $('#chq-filter-overlay');
    openBtn = $('[data-chq-open-overlay]');
    if (!overlay || !openBtn) return;

    closeBtn   = $('[data-chq-close-overlay]', overlay);
    clearBtn   = $('[data-chq-clear-all]', overlay);
    tabs       = $$('[data-chq-tab]', overlay);
    panes      = $$('.chq-filter-overlay__pane', overlay);
    form       = $('#chq-filter-form');
    applyBtn   = $('[data-chq-apply]', overlay);
    sortRadios = $$('[data-chq-sort-radio]', overlay);
    countEl    = $('[data-chq-result-count]', overlay);

    /* Move overlay to <body> to escape any ancestor containing-block trap */
    if (overlay.parentElement !== document.body) {
      try { document.body.appendChild(overlay); } catch (e) {}
    }

    bindOpenClose();
    bindTabs();
    bindSortRadios();
    bindCapacityChips();
    bindToggleList();
    bindShowMore();
    bindFacetSearch();
    bindClearCategory();
    bindRangeSlider();
    bindLiveCount();
    bindActivePillsBar();

    /* === v7 Baymard add-ons === */
    ensurePillsHost();
    ensureEmptyBanner();
    bindPillRemoval();
    bindFormChangeUiSync();
    renderActivePills();
    updateSelectedPreviews();
    updateSortTabLabel();
  }

  /* ---------- OPEN / CLOSE ---------- */
  function openOverlay() {
    if (!overlay) return;
    lastFocused = document.activeElement;
    overlay.setAttribute('data-open', 'true');
    document.documentElement.classList.add('chq-overlay-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (closeBtn) try { closeBtn.focus(); } catch (e) {} }, 50);
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.setAttribute('data-open', 'false');
    document.documentElement.classList.remove('chq-overlay-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  function bindOpenClose() {
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.getElementById('chq-facet-source') && form && !form.querySelector('[data-chq-facet-input]')) {
        try { hydrateMobileFacetsFromSource(); scheduleLiveCount(); } catch (err) {}
      }
      openOverlay();
    });
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.getAttribute('data-open') === 'true') {
        closeOverlay();
      }
    });
  }

  /* ---------- TABS ---------- */
  function bindTabs() {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-chq-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.setAttribute('data-active', p.id === 'chq-pane-' + key ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- SORT ---------- */
  function bindSortRadios() {
    sortRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!form) return;
        var hidden = form.querySelector('input[name="sort_by"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'sort_by';
          form.appendChild(hidden);
        }
        hidden.value = r.value;
        scheduleLiveCount();
      });
    });
  }

  /* ---------- CAPACITY CHIPS ---------- */
  function bindCapacityChips() {
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-chq-capacity-chips] .chq-chip');
      if (!chip) return;
      e.preventDefault();
      var min = parseInt(chip.getAttribute('data-min') || '0', 10);
      var max = parseInt(chip.getAttribute('data-max') || '999999', 10);
      var details = chip.closest('details');
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      var siblings = $$('[data-chq-capacity-chips] .chq-chip', chip.closest('[data-chq-capacity-chips]'));
      siblings.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      if (details) {
        $$('[data-chq-facet-input]', details).forEach(function (cb) { cb.checked = false; });
      }
      if (!pressed) {
        chip.setAttribute('aria-pressed', 'true');
        if (details) {
          $$('[data-chq-facet-input]', details).forEach(function (cb) {
            var num = parseInt(cb.getAttribute('data-numeric-value') || '0', 10);
            if (num >= min && num <= max) cb.checked = true;
          });
        }
      }
      scheduleLiveCount();
    });
  }

  /* ---------- TOGGLE EXACT-LBS LIST ---------- */
  function bindToggleList() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-chq-toggle-list]');
      if (!btn) return;
      e.preventDefault();
      var details = btn.closest('details');
      if (!details) return;
      var list = $('.chq-facet__list', details);
      if (!list) return;
      var collapsed = list.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
      btn.textContent = collapsed ? 'Browse exact lbs ▾' : 'Hide exact lbs ▴';
    });
  }

  /* ---------- SHOW MORE ---------- */
  function bindShowMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-chq-show-more]');
      if (!btn) return;
      e.preventDefault();
      var details = btn.closest('details');
      if (!details) return;
      var list = $('.chq-facet__list', details);
      if (list) list.classList.remove('is-truncated');
      btn.style.display = 'none';
    });
  }

  /* ---------- FACET SEARCH ---------- */
  function bindFacetSearch() {
    document.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('[data-chq-facet-search]')) return;
      var details = inp.closest('details');
      var q = (inp.value || '').toLowerCase().trim();
      $$('.chq-facet__list li', details).forEach(function (li) {
        var lbl = (li.textContent || '').toLowerCase();
        li.style.display = (q === '' || lbl.indexOf(q) !== -1) ? '' : 'none';
      });
    });
  }

  /* ---------- CLEAR CATEGORY ---------- */
  function bindClearCategory() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-chq-clear-category]');
      if (!btn) return;
      e.preventDefault();
      var details = btn.closest('details');
      if (!details) return;
      $$('[data-chq-facet-input]', details).forEach(function (cb) { cb.checked = false; });
      $$('input[type="number"]', details).forEach(function (inp) { inp.value = ''; });
      $$('[data-chq-capacity-chips] .chq-chip', details).forEach(function (c) {
        c.setAttribute('aria-pressed', 'false');
      });
      btn.style.display = 'none';
      scheduleLiveCount();
    });
  }

  /* ---------- PRICE RANGE SLIDER ---------- */
  function bindRangeSlider() {
    $$('[data-chq-range-slider]').forEach(function (slider) {
      var minH = $('[data-chq-slider-min]', slider);
      var maxH = $('[data-chq-slider-max]', slider);
      var fill = $('[data-chq-range-fill]', slider);
      var rangeWrap = slider.closest('.chq-facet__range');
      var minI = rangeWrap ? $('[data-chq-range-min]', rangeWrap) : null;
      var maxI = rangeWrap ? $('[data-chq-range-max]', rangeWrap) : null;
      var rangeMax = parseInt(slider.getAttribute('data-range-max'), 10) || 100;

      function update() {
        var minV = parseInt(minH.value, 10);
        var maxV = parseInt(maxH.value, 10);
        if (minV > maxV) { var t = minV; minV = maxV; maxV = t; }
        if (fill) {
          fill.style.left  = (minV / rangeMax * 100) + '%';
          fill.style.right = (100 - maxV / rangeMax * 100) + '%';
        }
        if (minI) minI.value = minV;
        if (maxI) maxI.value = maxV;
      }
      [minH, maxH].forEach(function (h) {
        if (h) h.addEventListener('input', update);
        if (h) h.addEventListener('change', scheduleLiveCount);
      });
      update();
    });
  }

  /* ---------- LIVE RESULT COUNT (debounced fetch) ---------- */
  var liveCountTimer = null;
  function scheduleLiveCount() {
    clearTimeout(liveCountTimer);
    liveCountTimer = setTimeout(fetchLiveCount, 350);
  }

  function bindLiveCount() {
    if (!form) return;
    form.addEventListener('change', function () { scheduleLiveCount(); });
  }

  function fetchLiveCount() {
    if (!form) return;
    if (applyBtn) applyBtn.classList.add('is-loading');
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function(v,k){ if(v===''||v==null) return; if(k==='filter.v.price.gte'&&(String(v).trim()===''||String(v)==='0'||Number(v)===0)) return; if(k==='filter.v.price.lte'&&String(v).trim()==='') return; params.append(k,v); });
    var qs = params.toString();
    var url = (form.action || window.location.pathname) + (qs ? '?' + qs : '');
    try {
      fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCountEl = doc.querySelector('[data-chq-result-count]');
          if (newCountEl && countEl) {
            countEl.textContent = newCountEl.textContent;
          }
          /* === v5: sync per-facet counts + disabled state from server truth === */
          try { syncFacetStateFromDoc(doc); } catch (e) { /* never break overlay */ }
          if (applyBtn) applyBtn.classList.remove('is-loading');
        })
        .catch(function () {
          if (applyBtn) applyBtn.classList.remove('is-loading');
        });
    } catch (e) {
      if (applyBtn) applyBtn.classList.remove('is-loading');
    }
  }

  /* ---------- v8: LIVE FACET STATE SYNC ----------
     Reads the server-rendered HTML for the current filter state and mirrors:
       1) per-option count "(X)" labels
       2) is-disabled class + disabled attribute for options that WOULD
          produce zero additional results.
     Key insight (v8): Shopify's filter API DROPS zero-count values from the
     response entirely — they're not returned with disabled=true, they're just
     absent. So the only reliable signal is: if a name|value pair that's in
     the CURRENT DOM is MISSING from the fetched HTML → it's a 0 option.
     Never touches CHECKED inputs (user must be able to uncheck them).
     Fails silently — overlay UX is untouched if parsing / DOM shape changes.
  ---------------------------------------------------- */
  function syncFacetStateFromDoc(doc) {
    if (!doc) return;

    /* === ZERO-RESULT GUARD (v6) === */
    var fetchedCountEl = doc.querySelector('[data-chq-result-count]');
    var fetchedCountRaw = fetchedCountEl ? (fetchedCountEl.textContent || '').replace(/[^0-9]/g, '') : '';
    var fetchedCount = fetchedCountRaw === '' ? null : parseInt(fetchedCountRaw, 10);

    if (fetchedCount === 0) {
      var allInputs = document.querySelectorAll('[data-chq-facet-input]');
      for (var z = 0; z < allInputs.length; z++) {
        var zi = allInputs[z];
        var zr = zi.closest ? (zi.closest('.chq-facet__opt') || zi.closest('li')) : null;
        if (!zr) continue;
        if (zi.checked) {
          zr.classList.remove('is-disabled');
          zi.removeAttribute('disabled');
        } else {
          zr.classList.add('is-disabled');
          zi.setAttribute('disabled', 'disabled');
          var zCnt = zr.querySelector('.chq-facet__opt-count');
          if (zCnt) zCnt.textContent = '(0)';
        }
      }
      if (applyBtn) applyBtn.classList.add('is-no-results');
      if (overlay) overlay.setAttribute('data-no-results', 'true');
      return;
    }

    if (applyBtn) applyBtn.classList.remove('is-no-results');
    if (overlay) overlay.removeAttribute('data-no-results');

    var jsonData = parseChqFacetSource(doc);
    var fetched = doc.querySelectorAll('[data-chq-facet-input]');
    /* T2 / Approach A: prefer JSON source whenever present so hydrate + live-count stay aligned */
    if (jsonData && doc.getElementById('chq-facet-source')) {
      syncFacetStateFromJson(jsonData);
      return;
    }
    if ((!fetched || !fetched.length) && jsonData) {
      syncFacetStateFromJson(jsonData);
      return;
    }
    if (!fetched || !fetched.length) return;

    /* Build server-truth map: name|value -> { count } — presence = available. */
    var map = Object.create(null);
    for (var i = 0; i < fetched.length; i++) {
      var fi = fetched[i];
      var name = fi.getAttribute('name');
      var val  = fi.getAttribute('value');
      if (!name || val === null) continue;
      var row = fi.closest ? (fi.closest('.chq-facet__opt') || fi.closest('li')) : null;
      var cntEl = row ? row.querySelector('.chq-facet__opt-count') : null;
      var cntText = cntEl ? (cntEl.textContent || '').trim() : null;
      map[name + '|' + val] = { count: cntText };
    }

    /* === KEY FIX (v8): figure out which facet-NAMES appeared in the fetched
       doc. A name that's present in current DOM but has ZERO entries in the
       fetched map means Shopify is actively filtering that facet — its values
       were pruned. We should only mark "absent => 0" for facet-names that
       Shopify's response still considers active. */
    var fetchedNames = Object.create(null);
    for (var k in map) {
      fetchedNames[k.split('|')[0]] = true;
    }

    /* Apply to current DOM */
    var current = document.querySelectorAll('[data-chq-facet-input]');
    for (var j = 0; j < current.length; j++) {
      var ci = current[j];
      var cName = ci.getAttribute('name');
      var cVal  = ci.getAttribute('value');
      if (!cName || cVal === null) continue;

      var cRow = ci.closest ? (ci.closest('.chq-facet__opt') || ci.closest('li')) : null;
      if (!cRow) continue;

      /* NEVER disable an already-checked box — user needs to be able to uncheck */
      if (ci.checked) {
        cRow.classList.remove('is-disabled');
        ci.removeAttribute('disabled');
        var chkCntEl = cRow.querySelector('.chq-facet__opt-count');
        var chkState = map[cName + '|' + cVal];
        if (chkCntEl && chkState && chkState.count !== null) {
          chkCntEl.textContent = chkState.count;
        }
        continue;
      }

      var state = map[cName + '|' + cVal];
      var cCntEl = cRow.querySelector('.chq-facet__opt-count');

      if (state) {
        /* Option still available — update count, clear disabled */
        if (cCntEl && state.count !== null) {
          cCntEl.textContent = state.count;
        }
        cRow.classList.remove('is-disabled');
        ci.removeAttribute('disabled');
      } else if (fetchedNames[cName]) {
        /* Option DROPPED from response BUT the facet itself still exists
           → this option would yield 0. Disable it. */
        cRow.classList.add('is-disabled');
        ci.setAttribute('disabled', 'disabled');
        if (cCntEl) cCntEl.textContent = '(0)';
      } else {
        /* Facet not present in fetched doc at all (e.g. Shopify dropped
           the whole facet because no meaningful filtering left). Leave
           unchanged — don't false-disable. */
      }
    }
  }

  /* ---------- ACTIVE PILLS BAR (already rendered by Liquid; just ensure clicks navigate) ---------- */
  function bindActivePillsBar() {
    /* No-op: pills are <a> links, browser handles nav. Reserved for future. */
  }

  /* ============================================================================
     v7: BAYMARD ADD-ONS
     - Active filter pills inside overlay body (Baymard #62)
     - Selected-values preview on collapsed accordions (Baymard #41)
     - Empty-state copy when 0 results (Baymard #88)
     - Sort tab dynamic label "Sort: Best selling" (Baymard #29)
     ============================================================================ */
  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getInputLabelText(input) {
    /* Try associated <label>, fall back to row text minus the (count) */
    var row = input.closest ? (input.closest('.chq-facet__opt') || input.closest('li')) : null;
    if (row) {
      var lbl = row.querySelector('.chq-facet__opt-label');
      if (lbl && lbl.textContent) return lbl.textContent.trim();
      var clone = row.cloneNode(true);
      var cnt = clone.querySelector('.chq-facet__opt-count');
      if (cnt) cnt.parentNode.removeChild(cnt);
      var inps = clone.querySelectorAll('input');
      for (var k = 0; k < inps.length; k++) inps[k].parentNode.removeChild(inps[k]);
      var t = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    return input.getAttribute('value') || '';
  }

  function getFacetTitle(detailsEl) {
    if (!detailsEl) return '';
    var sum = detailsEl.querySelector('.chq-facet__summary');
    if (!sum) return '';
    var clone = sum.cloneNode(true);
    /* Strip count badges, chevrons, clear-cat buttons */
    var strip = clone.querySelectorAll('.chq-facet__count, .chq-facet__chevron, [data-chq-clear-category], .chq-facet__selected-preview');
    for (var i = 0; i < strip.length; i++) strip[i].parentNode.removeChild(strip[i]);
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensurePillsHost() {
    if (!overlay) return;
    var body = overlay.querySelector('.chq-filter-overlay__body');
    if (!body) return;
    if (body.querySelector('[data-chq-overlay-pills]')) return;
    var host = document.createElement('div');
    host.className = 'chq-overlay-pills';
    host.setAttribute('data-chq-overlay-pills', '');
    host.setAttribute('aria-label', 'Active filters');
    host.hidden = true;
    body.insertBefore(host, body.firstChild);
  }

  function ensureEmptyBanner() {
    if (!overlay) return;
    var body = overlay.querySelector('.chq-filter-overlay__body');
    if (!body) return;
    if (body.querySelector('[data-chq-empty-state]')) return;
    var banner = document.createElement('div');
    banner.className = 'chq-overlay-empty';
    banner.setAttribute('data-chq-empty-state', '');
    banner.innerHTML =
      '<div class="chq-overlay-empty__title">No products match these filters</div>' +
      '<div class="chq-overlay-empty__body">Try removing a filter above to see more results. Tap any active filter to remove it.</div>';
    /* Insert right after pills host so it's above facets */
    var pills = body.querySelector('[data-chq-overlay-pills]');
    if (pills && pills.nextSibling) {
      body.insertBefore(banner, pills.nextSibling);
    } else if (pills) {
      body.appendChild(banner);
    } else {
      body.insertBefore(banner, body.firstChild);
    }
  }

  function renderActivePills() {
    if (!overlay) return;
    var host = overlay.querySelector('[data-chq-overlay-pills]');
    if (!host) return;

    var checked = overlay.querySelectorAll('[data-chq-facet-input]:checked');
    if (!checked.length) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < checked.length; i++) {
      var inp = checked[i];
      var name = inp.getAttribute('name') || '';
      var val  = inp.getAttribute('value') || '';
      var label = getInputLabelText(inp);
      html +=
        '<button type="button" class="chq-overlay-pill" ' +
          'data-chq-remove-pill ' +
          'data-name="' + escHtml(name) + '" ' +
          'data-value="' + escHtml(val) + '" ' +
          'aria-label="Remove filter ' + escHtml(label) + '">' +
          '<span class="chq-overlay-pill__label">' + escHtml(label) + '</span>' +
          '<span class="chq-overlay-pill__x" aria-hidden="true">&times;</span>' +
        '</button>';
    }
    /* Clear-all */
    html +=
      '<button type="button" class="chq-overlay-pill chq-overlay-pill--clear" data-chq-pills-clear-all>' +
        'Clear all' +
      '</button>';

    host.innerHTML = html;
    host.hidden = false;
  }

  function updateSelectedPreviews() {
    if (!overlay) return;
    var facets = overlay.querySelectorAll('details.chq-facet');
    for (var i = 0; i < facets.length; i++) {
      var d = facets[i];
      var summary = d.querySelector('.chq-facet__summary');
      if (!summary) continue;
      var preview = summary.querySelector('.chq-facet__selected-preview');
      var checked = d.querySelectorAll('[data-chq-facet-input]:checked');
      if (!preview) {
        preview = document.createElement('span');
        preview.className = 'chq-facet__selected-preview';
        summary.appendChild(preview);
      }
      if (!checked.length) {
        preview.textContent = '';
        preview.hidden = true;
        continue;
      }
      var labels = [];
      for (var j = 0; j < checked.length && j < 3; j++) {
        labels.push(getInputLabelText(checked[j]));
      }
      var extra = checked.length - labels.length;
      var text = labels.join(', ');
      if (extra > 0) text += ' +' + extra + ' more';
      preview.textContent = text;
      preview.hidden = false;
    }
  }

  function updateSortTabLabel() {
    if (!overlay) return;
    var sortTab = overlay.querySelector('[data-chq-tab="sort"]');
    if (!sortTab) return;
    var checkedSort = overlay.querySelector('[data-chq-sort-radio]:checked');
    var labelText = '';
    if (checkedSort) {
      var sortRow = checkedSort.closest('.chq-sort-list__opt') || checkedSort.parentElement;
      if (sortRow) {
        var clone = sortRow.cloneNode(true);
        var ins = clone.querySelectorAll('input');
        for (var k = 0; k < ins.length; k++) ins[k].parentNode.removeChild(ins[k]);
        labelText = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      }
    }
    if (!sortTab.hasAttribute('data-chq-base-label')) {
      sortTab.setAttribute('data-chq-base-label', (sortTab.textContent || 'Sort').trim());
    }
    var base = sortTab.getAttribute('data-chq-base-label') || 'Sort';
    sortTab.textContent = labelText ? (base + ': ' + labelText) : base;
  }

  function bindPillRemoval() {
    if (!overlay) return;
    overlay.addEventListener('click', function (e) {
      var clearAll = e.target.closest && e.target.closest('[data-chq-pills-clear-all]');
      if (clearAll) {
        e.preventDefault();
        var inputs = overlay.querySelectorAll('[data-chq-facet-input]:checked');
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].checked = false;
        }
        /* Also clear capacity chips visual state */
        var chips = overlay.querySelectorAll('[data-chq-capacity-chips] .chq-chip[aria-pressed="true"]');
        for (var c = 0; c < chips.length; c++) chips[c].setAttribute('aria-pressed', 'false');
        /* Reset numeric range inputs */
        var nums = overlay.querySelectorAll('input[type="number"]');
        for (var n = 0; n < nums.length; n++) nums[n].value = '';
        renderActivePills();
        updateSelectedPreviews();
        scheduleLiveCount();
        return;
      }
      var pill = e.target.closest && e.target.closest('[data-chq-remove-pill]');
      if (!pill) return;
      e.preventDefault();
      var name = pill.getAttribute('data-name');
      var val  = pill.getAttribute('data-value');
      if (!name || val === null) return;
      var sel = '[data-chq-facet-input][name="' + name.replace(/"/g, '\\"') + '"][value="' + val.replace(/"/g, '\\"') + '"]';
      var match = overlay.querySelector(sel);
      if (match) {
        match.checked = false;
        try { match.dispatchEvent(new Event('change', { bubbles: true })); } catch (er) {
          var ev = document.createEvent('Event'); ev.initEvent('change', true, true); match.dispatchEvent(ev);
        }
      }
      renderActivePills();
      updateSelectedPreviews();
      scheduleLiveCount();
    });
  }

  function bindFormChangeUiSync() {
    if (form) {
      form.addEventListener('change', function () {
        renderActivePills();
        updateSelectedPreviews();
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-chq-sort-radio]')) {
        updateSortTabLabel();
      }
    });
  }

  /* ---------- BOOTSTRAP ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Re-run init if page is dynamically updated (e.g. SPA-style nav) */
  window.__chqMobileFilterInit = function () {
    try { init(); } catch (e) {}
  };
})();
